import React, { useState, useMemo } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useAccountUIContext } from "../AccountUIContext";
import { NoRecordField } from "app/components/template/partials";

export function AccountProfileDetail() {
  const accountUIContext = useAccountUIContext();
  const accountUIProps = useMemo(() => {
    return {
      data: accountUIContext.data,
      goToAccountProfileEdit: accountUIContext.goToAccountProfileEdit,
    };
  }, [accountUIContext]);
  const { data, goToAccountProfileEdit } = accountUIProps;
  const [actionCard, setActionCard] = useState(null);

  return (
    <Card>
      <CardHeader
        title="Profil"
        action={
          <IconButton
            aria-label="settings"
            onClick={(event) => setActionCard(event.currentTarget)}
          >
            <MoreVertIcon />
          </IconButton>
        }
      />
      <Menu
        id="simple-menu"
        anchorEl={actionCard}
        open={Boolean(actionCard)}
        onClose={() => setActionCard(null)}
      >
        <MenuItem onClick={() => goToAccountProfileEdit(data?.username)}>
          Edit
        </MenuItem>
      </Menu>
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={12} xs={12}>
            <Typography color="textSecondary" variant="body2">
              NAMA USER
            </Typography>
            <Typography color="textPrimary" gutterBottom variant="h6">
              {NoRecordField(data?.username)}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography color="textSecondary" variant="body2">
              EMAIL
            </Typography>
            <Typography color="textPrimary" gutterBottom variant="h6">
              {NoRecordField(data?.email)}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography color="textSecondary" variant="body2">
              KETERANGAN
            </Typography>
            <Typography color="textPrimary" gutterBottom variant="h6">
              {NoRecordField(data?.keterangan)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
